import React from "react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";

import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";

const FilterButtonWithLabel = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      data-cy="filter-button"
      buttonColor={colors.primaryColor}
      label={formatMessage({ id: "common.filters" })}
      iconName="filter_list"
      {...props}
    />
  );
};

export default FilterButtonWithLabel;
